import styled from 'styled-components'
import { themeColor } from 'LibNeo'

export const ContentBlockContainer = styled.div<{
	centered?: boolean
	withoutHeader?: boolean
	withoutShadow?: boolean
	smallIndent?: boolean
}>`
	margin: 0;
	width: 100%;
	padding: 32px 40px 40px 40px;
	border-radius: 8px;
	border: 1px solid ${themeColor('gray', 3)};
	background-color: ${themeColor('white')};
	box-shadow: 12px 12px 8px rgba(223, 227, 232, 0.2);
	box-shadow: ${({ withoutShadow }) => withoutShadow && 'none'};
	margin: ${({ centered }) => centered && 'auto'};
	padding: ${({ withoutHeader }) => withoutHeader && '40px'};
	padding: ${({ smallIndent }) => smallIndent && '32px'};
`
